module.exports = __webpack_public_path__ + "img/scanlogo.afc13fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scanlogo.png
// module id = et4g
// module chunks = 1